<template>
  <div>
    <LessonContentUnlockCodeModal
      :isOpen="openModal"
      :close="changeModal"
      :reload="reload"
      :lessonContentUnlockCode="selectedLessonContentUnlockCode"
      :lessonContents="lessonContents"
      v-if="openModal"
    />
    <BulkCreateLessonContentUnlockCodeModal
      :isOpen="openBulkModal"
      :close="changeBulkModal"
      :reload="reload"
      :lessonContents="lessonContents"
      v-if="openBulkModal"
    />
    <div class="inline-block min-width-full overflow-hidden rounded-lg shadow bg-white p-4">
      <b-row class="my-4 min-width-full align-items-center">
        <b-col md="4">
          <b-input-group>
            <b-form-input
              id="inline-form-input-name"
              class=" mr-sm-2 md-4"
              placeholder="접속 코드 또는 강의명을 입력하세요."
              v-model="searchKey"
              v-on:keyup.enter="handleSearch"
            ></b-form-input>
            <b-input-group-append>
              <button class="btn btn-primary" v-on:click="handleSearch">검색</button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col md="2" class="text-left">
          <b-form-checkbox
            v-model="checkDeleted"
            v-on:click="handleChangeCheckbox()"
            class="mt-sm"
          >
            삭제포함
          </b-form-checkbox>
        </b-col>
        <b-col md="6" class="text-right inline-flex gap-2 justify-content-end">
          <Button :type="ButtonTypes.green" label="등록" :on-click="changeModal"/>
          <Button :type="ButtonTypes.purple" label="난수코드 생성" :on-click="changeBulkModal"/>
          <Button :type="ButtonTypes.blue" label="엑셀 다운로드" :on-click="exportExcel" :loading="loading.excel"/>
          <Button :type="ButtonTypes.red" label="전체 삭제" :on-click="deleteAll"/>
        </b-col>
      </b-row>
      <b-table :fields="fields" :items="searchLessonContentUnlockCodes" class="text-left">
        <template #cell(startedAt)="data">
          {{ getDate(data.item.startedAt)}}
        </template>
        <template #cell(endedAt)="data">
          {{ getDate(data.item.endedAt)}}
        </template>
        <template #cell(title)="data">
          {{`${data.item.lessonTitle} (${data.item.lessonContentTitle})`}}
        </template>
        <template #cell(button)="data">
          <div class="inline-flex justify-end gap-1 w-full"  v-if="!data.item.deletedAt">
            <b-button variant=warning class="text-white" v-on:click="setDetail(data.item)">수정</b-button>
            <b-button variant="danger" v-on:click="deleteItem(data.item.id, data.item.code)">삭제</b-button>
          </div>
          <div v-else class="text-right text-gray-500">
            {{`${getDate(data.item.deletedAt)} 삭제`}}
          </div>
        </template>
      </b-table>
      <b-pagination
        align="center"
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="pageSize"
        @page-click="changePage"
      />
    </div>
  </div>
</template>
<script>
import api from "@/api/api";
import {ButtonTypes} from "@/util/enums";
import customDate from "@/util/custom-date";
import LessonContentUnlockCodeModal from "@/components/modals/LessonContentUnlockCodeModal.vue";
import Button from "@/components/Button.vue";
import BulkCreateLessonContentUnlockCodeModal from "@/components/modals/BulkCreateLessonContentUnlockCodeModal.vue";
import Excel from "@/util/excel";

export default {
  components: {BulkCreateLessonContentUnlockCodeModal, Button, LessonContentUnlockCodeModal},
  computed: {
    ButtonTypes() {
      return ButtonTypes
    },
  },
  data() {
    return {
      searchLessonContentUnlockCodes: [],
      currentPage: 1,
      pageSize: 30,
      totalPage: 0,
      totalRows: 0,
      checkDelete: false,
      openModal: false,
      openBulkModal: false,
      searchKey: "",
      lessonContents: [],
      loading: {
        excel: false,
      },
      selectedLessonContentUnlockCode: null,
      fields: [
        {
          label: '강의 접속코드',
          key: "code",
        },
        {
          label: '강의명',
          key: 'title',
        },
        {
          label: '시작일자',
          key: 'startedAt',
        },
        {
          label: '종료일자',
          key: 'endedAt',
        },
        {
          label: '',
          key: 'button',
          thStyle: { width: "20%" },
        }
      ],
      checkDeleted: false
    }
  },
  mounted() {
    // URL query params에서 상태 복원
    const query = this.$route.query
    if (query.page) {
      this.currentPage = parseInt(query.page)
    }
    if (query.keyword) {
      this.searchKey = query.keyword
    }
    if (query.checkDeleted === 'true') {
      this.checkDeleted = true
    }
    
    this.getLessonContents()
    this.getPagingList(this.currentPage)
  },
  methods: {
    getLessonContents () {
      api.lesson.lessonContents({
        hasSiblings: true
      },(response) => {
        this.lessonContents = response.data
      }, (err) => {
        console.log(err)
      })
    },
    handleChangeCheckbox() {
      this.checkDeleted = !this.checkDeleted
      this.currentPage = 1
      this.updateQueryParams()
      this.getPagingList(1)
    },
    handleSearch() {
      this.currentPage = 1
      this.updateQueryParams()
      this.getPagingList(1)
    },
    updateQueryParams() {
      const query = {
        page: this.currentPage.toString()
      }
      
      if (this.searchKey) {
        query.keyword = this.searchKey
      }
      if (this.checkDeleted) {
        query.checkDeleted = 'true'
      }
      
      this.$router.replace({ query })
    },
    getDate(date){
      return customDate.stringFormat(date)
    },
    changeModal() {
      this.openModal = !this.openModal
      if (!this.openModal) {
        this.selectedLessonContentUnlockCode = null
      }
    },
    changeBulkModal() {
      this.openBulkModal = !this.openBulkModal
    },
    setDetail(lessonContentUnlockCode) {
      this.selectedLessonContentUnlockCode = lessonContentUnlockCode
      this.changeModal()
    },
    reload(){
      this.currentPage = 1
      this.updateQueryParams()
      this.getPagingList(1)
    },
    changePage(event, page){
      this.currentPage = page
      this.updateQueryParams()
      this.getPagingList(this.currentPage)
    },
    deleteItem(id, code) {
      this.$store.dispatch('modal/openModal', {
        type: 'warning',
        title: '접속 코드 삭제',
        html: `접속 코드(${code})를 삭제 하면 해당 코드를 더 이상 사용할 수 없으며, 이미 이 코드를 통해 수강 중이던 학생들도 수강이 중단됩니다. 정말 삭제하시겠습니까?`,
        confirm: () => {
          api.lessonContentUnlockCode.delete(id,(response) => {
            this.$toast.show('삭제 완료',
              {
                position: "top-right",
              })
            this.getPagingList(this.currentPage)
          }, (err) => {
            console.log(err)
          })
        }
      });
    },
    exportExcel() {
      let param = {
        searchKeyword: this.searchKey,
        showDeleted: this.checkDeleted
      }
      this.loading.excel = true
      api.lessonContentUnlockCode.exportExcel(
        param,
        (response) => {
          Excel.download(response.data, '접속 코드_생성')
          this.loading.excel = false
          this.$toast.success('엑셀 다운로드 완료',
            {
              position: "top-right",
              duration: 2000
            })
        }, (e) => {
          console.error(e)
          this.loading.excel = false
          this.$toast.error('엑셀 추출 실패',
            {
              position: "top-right",
              duration: 2000,
            });
        })

    },
    deleteAll() {
      this.$store.dispatch('modal/openModal', {
        type: 'warning',
        title: '접속 코드 전체 삭제',
        html: '접속 코드를 삭제하면 해당 코드를 더 이상 사용할 수 없으며, 이미 이 코드를 통해 수강 중이던 학생들도 수강이 중단됩니다. 정말 삭제하시겠습니까?',
        confirm: () => {
          api.lessonContentUnlockCode.deleteAll((response) => {
            this.searchLessonContentUnlockCodes = []
            this.totalPage = 0
            this.totalRows = 0
            this.currentPage = 1
            this.$toast.show('전체 삭제 완료',
              {
                position: "top-right",
                duration: 2000
              })
          }, (err) => {
            console.log(err)
          })
        }
      });
    },
    getPagingList(page) {
      let param = {
        page: page,
        searchKeyword: this.searchKey,
        showDeleted: this.checkDeleted
      }
      
      api.lessonContentUnlockCode.search(param,(response) => {
        const {content, totalPages, totalElements} = response.data
        this.searchLessonContentUnlockCodes = content
        this.totalPage = totalPages
        this.totalRows = totalElements
        this.currentPage = page
      }, (err) => {
        console.log(err)
      })
    }
  }
}
</script>
<style scoped>
.text-right{
  text-align: right;
}
</style>